export default {
  strict: true,
  namespaced: true,
  state: {
    isShow: false,
  },
  mutations: {
    show(state) {
      state.isShow = true;
    },
    hide(state) {
      state.isShow = false;
    },
  },
  actions: {
    show({ commit, state }, payload) {
      commit('show');
      commit('destinationDetail/hide', null, { root: true });
      commit('searchResult/clearDestination', null, { root: true });
    },
  },
};



// WEBPACK FOOTER //
// ./src/stores/map/views/destination_list.js